/*
 * Copyright (c) All right reserved Anvish Inc. 2025
 * This project and any portion thereof may not be reproduced or used in any manner without the express written permission of Anvish Inc.
 */
export function logError(error: unknown, context?: Record<string, any>) {
  console.error("🔥 APP ERROR", {
    message: error instanceof Error ? error.message : error,
    stack: error instanceof Error ? error.stack : null,
    context,
  });
}
